import axios from 'axios';

/**
 * 從 API 錯誤中取出 server response message。
 * 優先讀取 axios error 的 response.data.message，若不存在則回傳 fallback。
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError<{ message?: string }>(error)) {
    return error.response?.data?.message || fallback;
  }
  return fallback;
}
